export const FaqData = [
  {
    title: 'What is JioPay 1QR ?',
    isParagraph: true,
    subheading:
      'JioPay 1QR offers a simple and effective way for you to accept UPI payments to your linked merchant account with your Reliance partner brand.',
  },
  {
    title: 'How do I accept payments via JioPay 1QR ?',
    isParagraph: true,
    subheading:
      'Your JioPay 1 QR is already linked with your merchant account. Your customer can scan the QR using any UPI app (My Jio, Phone Pe, GooglePay or any BHIM/UPI app) and make a payment.',
  },
  {
    title: 'When will the funds be credited to my account ?',
    isParagraph: true,
    subheading: 'Funds will be credited to your account in T+1(1 day after the transaction)',
  },
  {
    title: 'Where do I see my transaction history of all payments and funds received ?',
    isParagraph: true,
    subheading:
      'You can login to https://dashboard.jiopay.com/login with your registered mobile number and password to view the transaction history and settlement of funds.',
  },
  {
    title: 'Where do I reach out for support/queries ?',
    isParagraph: true,
    subheading:
      'Please mail your queries to merchant.support@jiopay.in for any support related to transaction/settlement of funds or any other details or reach out to your Reliance brand partner.',
  },
]
